/* eslint-disable */
import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { Lock, CheckCircle } from 'lucide-react';
import axiosClient from '../api/axiosClient';
import toast from 'react-hot-toast';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const [resetToken, setResetToken] = useState(searchParams.get('token') || '');
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axiosClient.post('/auth/reset-password', { resetToken, newPassword });
      toast.success('Password updated successfully! Please login.');
      navigate('/admin/login');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Password reset failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 px-4 font-sans">
      <div className="w-full max-w-md bg-slate-900 border border-slate-800 p-8 rounded-3xl shadow-2xl space-y-6">
        <div>
          <h2 className="text-xl font-bold text-white">Set New Password</h2>
          <p className="text-xs text-slate-400 mt-1">Enter your reset token and your new secure password.</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-bold text-slate-400 mb-1">Reset Token</label>
            <input
              type="text"
              required
              value={resetToken}
              onChange={(e) => setResetToken(e.target.value)}
              placeholder="Paste token here..."
              className="w-full p-3 rounded-xl border border-slate-800 bg-slate-950 text-white text-sm"
            />
          </div>

          <div>
            <label className="block text-xs font-bold text-slate-400 mb-1">New Password</label>
            <div className="relative">
              <Lock className="absolute left-3.5 top-3.5 h-4 w-4 text-slate-500" />
              <input
                type="password"
                required
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="••••••••••••"
                className="w-full pl-10 pr-4 py-3 rounded-xl border border-slate-800 bg-slate-950 text-white text-sm"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded-xl font-bold text-sm bg-blue-600 hover:bg-blue-500 text-white flex items-center justify-center space-x-2"
          >
            <CheckCircle size={16} />
            <span>{loading ? 'Updating...' : 'Update Password'}</span>
          </button>
        </form>

        <div className="text-center pt-2">
          <Link to="/admin/login" className="text-xs text-slate-400 hover:text-white">
            Return to Login
          </Link>
        </div>
      </div>
    </div>
  );
}
